/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


import $ from 'jquery';
import 'select2/dist/js/select2.min.js';

$(document).ready(function () {
    if ($('.select2-filter-element').length) {
        $('.select2-filter-element').select2();
    }

    
    let template = $('.info-block-wrapper').html();
    let parser = new DOMParser();
    let doc = parser.parseFromString(template, 'text/html');
    let perPagePosts = 6;
    $('.info-block-wrapper').html('').show();

    $('.info-block-wrapper').html('')

    function decodeHTMLEntities(text) {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = text;
        return textarea.value;
    }

    function fetchFilteredPosts() {
        let selectedType = $('#resources-type-select').val();
        let selectedIndustry = $('#resources-industry-select').val();
        let selectedProduct = $('#resources-product-select').val();

        let filterUrl = `/wp-json/wp/v2/posts?per_page=${perPagePosts}&_embed`;

        if (selectedType) {
            filterUrl += `&resources-type=${selectedType}`;
        }
        if (selectedIndustry) {
            filterUrl += `&resources-industry=${selectedIndustry}`;
        }
        if (selectedProduct) {
            filterUrl += `&resources-product=${selectedProduct}`;
        }

        $('.info-block-wrapper').prepend('<div class="loadingio-spinner-ripple-nq4q5u6dq7r"><div class="ldio-x2uulkbinbj"><div></div><div></div></div></div>');
        $('.view-more-wrapper').hide();

        $.ajax({
            url: filterUrl,
            method: 'GET',
            success: function (posts, textStatus, jqXHR) {
                let generatedTemplate = '';
                const totalPosts = jqXHR.getResponseHeader('X-WP-Total');

                if (posts.length) {
                    $.each(posts, function (index, post) {
                        const resourceType = post['tpgb_post_meta_info']['category_list']['resources-type'] || [];
                        const resourceTypeNames = resourceType.map(term => term.name).join(', ');

                        const featuredImageUrl = post._embedded?.['wp:featuredmedia']?.[0]?.source_url || '';
                        const featuredImageTitle = post._embedded?.['wp:featuredmedia']?.[0]?.title['rendered'] || '';
                        const featuredImageID = post._embedded?.['wp:featuredmedia']?.[0]?.id || '';

                        let pinText = doc.querySelector('.info-pin-text ');
                        if (pinText) {
                            pinText.textContent = resourceTypeNames;
                        }

                        let imageSrc = doc.querySelector('.service-icon');
                        if (imageSrc) {
                            imageSrc.src = featuredImageUrl;
                            imageSrc.alt = featuredImageTitle;
                            imageSrc.removeAttribute('srcset');
                        }

                        let title = doc.querySelector('.service-title');
                        if (title) {
                            title.textContent = decodeHTMLEntities(post.title.rendered);
                            title.href = post.link;
                        }

                        let buttonLink = doc.querySelector('.button-link-wrap');
                        if (buttonLink) {
                            buttonLink.href = post.link;
                        }

                        generatedTemplate += doc.body.innerHTML;
                        if (totalPosts > perPagePosts) {
                            $('.view-more-wrapper').css('display', 'flex');
                        }
                    });
                } else {
                    generatedTemplate = '<p>No resources available.</p>';
                }
                $('.info-block-wrapper').html(generatedTemplate);

            },
            error: function (error) {
                console.log('Error fetching posts:', error);
            }
        });

    }

    $('#resources-type-select, #resources-industry-select, #resources-product-select').on('change', function () {
        perPagePosts = 6;
        fetchFilteredPosts();
    });

    $('.reset-btn-link').on('click', function (e) {
        perPagePosts = 6;
        e.preventDefault();
        $('.select2-filter-element').val(null).trigger('change');
        fetchFilteredPosts();
    });

    $('.more-btn-link').on('click', function (e) {
        e.preventDefault();
        perPagePosts += 6;
        fetchFilteredPosts();
    });

    fetchFilteredPosts();
});

